export enum OrganizationType {
  MANUFACTURER = 1,
  RETAILER = 2,
  PRIVATE_LABEL = 3,
  THIRD_PARTY = 4,
}
